jQuery('div.custom-preloader').fadeOut('fast').remove();

if(ipTempDetect == 'cart') {
  let interval
  jQuery(document).ready(function() {
    interval = setInterval(addCartCurrency, 1000);
  });
  function addCartCurrency() {
    if (jQuery('div.limoniapps-discountninja-cart-item-product-comment').is(':visible')) {
      var dicountsninja_currency = jQuery('span.limoniapps-discountninja-money').data('currency');
      if(dicountsninja_currency != 'MYR') {
        setTimeout(function() {
          jQuery('span.limoniapps-discountninja-money').each(function( index ) {
              var amount = jQuery(this).find('span.money').html();
              jQuery(this).find('span.money').html(amount + ' ' + dicountsninja_currency);
              jQuery('span.money').removeClass('limoniapps-discountninja-money');
              jQuery('td.cart-item__details > div').removeClass('limoniapps-discountninja-cart-item-product-comment');
              jQuery('div.product-option').removeClass('limoniapps-discountninja-cart-item-product-price');
              jQuery('div.cart-item__price-wrapper').removeClass('limoniapps-discountninja-cart-item-line-price');
              jQuery('div.cart__footer > div.cart__blocks > div.js-contents > div').removeClass('limoniapps-discountninja-cart-promotionsummary');
          });
        }, 1000);
        clearInterval(interval);
      }
    }
  }
  function refreshCartCurrency() {
    setTimeout(function() {
      var dicountsninja_currency = jQuery('span.limoniapps-discountninja-money').data('currency');
      jQuery('span.limoniapps-discountninja-money').each(function( index ) {
          var amount = jQuery(this).find('span.money').html();
          jQuery(this).find('span.money').html(amount + ' ' + dicountsninja_currency);
      });
    }, 5000);
  }
}

var shareIcon = '<svg class="sasa-font-pink" width="13" height="12" viewBox="0 0 13 12" class="icon icon-share" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M1.625 8.125V10.2917C1.625 10.579 1.73914 10.8545 1.9423 11.0577C2.14547 11.2609 2.42102 11.375 2.70833 11.375H10.2917C10.579 11.375 10.8545 11.2609 11.0577 11.0577C11.2609 10.8545 11.375 10.579 11.375 10.2917V8.125" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M6.14775 1.27137C6.34301 1.0761 6.65959 1.0761 6.85485 1.27137L9.56319 3.9797C9.75845 4.17496 9.75845 4.49154 9.56319 4.6868C9.36793 4.88207 9.05135 4.88207 8.85609 4.6868L6.5013 2.33203L4.14652 4.6868C3.95126 4.88207 3.63468 4.88207 3.43942 4.6868C3.24415 4.49154 3.24415 4.17496 3.43942 3.9797L6.14775 1.27137Z" fill="currentColor"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M6.5 1.125C6.77614 1.125 7 1.34886 7 1.625V8.125C7 8.40114 6.77614 8.625 6.5 8.625C6.22386 8.625 6 8.40114 6 8.125V1.625C6 1.34886 6.22386 1.125 6.5 1.125Z" fill="currentColor"></path></svg>';
jQuery('span.stamped-share-icon i.stamped-fa').html(shareIcon);

setTimeout(function() { 
  if(jQuery('span.card__custom-promotion').length > 0) {
    var currentDate = new Date(),
        currentDate = currentDate.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric', timeZone: 'Asia/Hong_Kong' });
    jQuery('span.card__custom-promotion').each(function( index ) {
      if((jQuery(this).data('end') != '') && (jQuery(this).data('start') != '')) {
        var end = new Date(jQuery(this).data('end')),
            end = end.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric', timeZone: 'Asia/Hong_Kong' });
        var start = new Date(jQuery(this).data('start')),
            start = start.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric', timeZone: 'Asia/Hong_Kong' });
        if(new Date(currentDate) >= new Date(start) && new Date(currentDate) < new Date(end)) {
          jQuery(this).css('display', 'inline-block');
        }
      }
    });
    if(ipTempDetect == 'product') {
      var $wrap = jQuery('div.card__custom-promotion_wrapper');
      $wrap.find('span.card__custom-promotion').sort(function(a, b) 
      {
        return +a.dataset.priority -
        +b.dataset.priority;
      })
      .appendTo($wrap);
      if(jQuery('span.card__custom-promotion').length > 0) {
        jQuery('div.card__custom-promotion_wrapper').append('<div class="card__custom-promotion_title sasa-font-pink">The deepest discount will be applied to the order and will be shown at the check-out page.</div>');
        jQuery('div.card__custom-promotion_title').css('display', 'block');
      }
    }
  }
}, 150);

if((ipTempDetect == 'collection') || (ipTempDetect == 'search')) {
  var previousScroll = 0;
  jQuery(window).scroll(function(){
      var currentScroll = jQuery(this).scrollTop();
      if (currentScroll > previousScroll) {
        if(jQuery('span.card__custom-promotion').length > 0) {
          var currentDate = new Date(),
              currentDate = currentDate.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric', timeZone: 'Asia/Hong_Kong' });
          jQuery('span.card__custom-promotion').each(function( index ) {
            if((jQuery(this).data('end') != '') && (jQuery(this).data('start') != '')) {
              var end = new Date(jQuery(this).data('end')),
                  end = end.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric', timeZone: 'Asia/Hong_Kong' });
              var start = new Date(jQuery(this).data('start')),
                  start = start.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric', timeZone: 'Asia/Hong_Kong' });
              if(new Date(currentDate) >= new Date(start) && new Date(currentDate) < new Date(end)) {
                jQuery(this).css('display', 'inline-block');
              }
            }
          });
        }
        jQuery('div.card--product div.card__badge > .badge').each(function( index ) {
          if(jQuery(this).html().length < 1) {
            var cap = jQuery(this).next().data('cap'), 
                prc = jQuery(this).next().data('prc'), 
                pid = jQuery(this).next().data('pid'),
                lazy_badge_final = Math.ceil((((cap - prc) / cap) * 100));
            jQuery('span.badge--' + pid).css('visibility', 'visible').html('Save ' + lazy_badge_final + '%');
          }
        });
      }
      previousScroll = currentScroll;
  });
}

setTimeout(function() { 
  jQuery('span.sharelabicon-share').html(shareIcon + ' Share');
}, 3000);

setTimeout(function() {
  if(jQuery('div.ssw-edit-profile-page').length > 0) {
    jQuery('div.ssw-edit-profile-page-heading').append('<a class="back" href="/account">Return to Account details</a>');
  }
}, 8000);

jQuery('button.product-form__submit').on('click', function() {
  gtag('event', 'conversion', {'send_to': 'AW-1072250739/cOl0CMWOgNADEPP-pP8D'});
  fbq('track', 'AddToCart');
});

jQuery('button[name="checkout"]').on('click', function() {
  gtag('event', 'conversion', {'send_to': 'AW-1072250739/cOl0CMWOgNADEPP-pP8D'});
  fbq('track', 'InitiateCheckout');
});